<template>
  <div>
    <ModalIdle v-if="isApp && isIdle" />
    <transition name="slide-fade-main"
                mode="out-in"
                appear>
      <router-view />
    </transition>
  </div>
</template>

<script>
import ModalIdle from '@components/ModalIdle';
import Auth from '@utils/auth';

export default {
  name: 'App',
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title;
    }
  },
  components: {
    ModalIdle
  },
  created() {
    window.addEventListener('storage', this.onStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === Auth.options.tokenDefaultName) {
        if (event.newValue) {
          this.$http.defaults.headers.common.Authorization = `Bearer ${event.newValue}`;
        } else if (!event.newValue && this.isApp) {
          Auth.options.logoutData.redirect = '/login';
          Auth.logout();
        }
      }
    }
  },
  computed: {
    isApp() {
      if (this.$route.name === 'admin.login') {
        return false;
      }
      return true;
    },
    isIdle() {
      if (this.$store.state.idleVue) {
        return this.$store.state.idleVue.isIdle;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
body {
  perspective: 1000px;
  overflow-x: hidden;
}

.slide-fade-main-enter-active {
  transition: all 0.35s ease-in;
}

.slide-fade-main-leave-active {
  transition: all 0.35s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-main-enter {
  transform: translateX(50px);
  opacity: 0;
}

.slide-fade-main-leave-to {
  transform: translateZ(-100px);
  transform-style: preserve-3d;
  opacity: 0.5;
}
</style>
